import React, { useCallback, useEffect, useState } from "react";
import { useLang } from "../context/LanguageContext";
import api from "../lib/api";
import { ReviewsSummary, ReviewList, ReviewForm } from "./reviews/ReviewParts";
import { logger } from "../lib/logger";

export const Reviews = ({ slug }) => {
  const { t, lang } = useLang();
  const [data, setData] = useState({ reviews: [], average: 0, count: 0 });

  const load = useCallback(() => {
    api.get(`/products/${slug}/reviews`).then((r) => setData(r.data)).catch((e) => logger.error("reviews load failed", e));
  }, [slug]);
  useEffect(() => { if (slug) load(); }, [slug, load]);

  return (
    <section className="max-w-[1400px] mx-auto px-5 md:px-10 mt-20 md:mt-28" data-testid="reviews-section">
      <div className="border-t border-[#262421] pt-14">
        <ReviewsSummary data={data} t={t} />
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
          <ReviewList reviews={data.reviews} t={t} lang={lang} />
          <div className="lg:sticky lg:top-24 lg:self-start">
            <ReviewForm slug={slug} t={t} onSubmitted={load} />
          </div>
        </div>
      </div>
    </section>
  );
};
